import type { Styles } from 'common/types';

export const styles: Styles = {
  ratingRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  textField: {
    '& .MuiInputBase-inputMultiline': {
      height: '110px !important',
      overflow: 'auto !important',
      resize: 'none !important',
    },
  },
  actions: {
    display: 'flex',
    gap: 1,
  },
};
